import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '../../../services';
import { SupplierInboxType } from '../../../enums/supplier-inbox.type.enum';

@Component({
  templateUrl: 'gamification-container.component.html',
  styleUrls: ['gamification-container.component.scss'],
})
export class GamificationContainerComponent implements OnInit {
  public loadingData = true;

  constructor(private router: Router, private eventService: EventService) {}

  ngOnInit() {}

  grabMovement() {
    this.router.navigate(['/app/supplierinbox'], {
      queryParams: { selectedTab: SupplierInboxType.InboxMatched, isGridView: false },
    });
  }
}
